import { c as _c } from "react/compiler-runtime";
import { DropdownSeparator } from "@opensea/ui-kit";
import { ContentCopy, Logout, Person, SwapHoriz } from "@opensea/ui-kit/icons";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { useAccount, useDisconnect } from "../../../../../polychain/hooks";
import { FlowActions } from "../../../../../stores/flowStore";
import { ProfileDropdownItem, ProfileDropdownItemAvatar, ProfileDropdownItemContent, ProfileDropdownItemTitle } from "./ProfileDropdownItem";
import { SwitchWalletContent } from "./SwitchWalletContent";
export function ProfileDropdownContent(t0) {
  const $ = _c(26);
  const {
    address
  } = t0;
  const t = useTranslations("wallet.ProfileDropdownContent");
  const {
    disconnect
  } = useDisconnect();
  const {
    address: connectedAddress
  } = useAccount();
  const isProfileOwner = connectedAddress === address;
  let t1;
  if ($[0] !== address) {
    t1 = () => {
      navigator.clipboard.writeText(address);
    };
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const copyAddress = t1;
  let t2;
  if ($[2] !== disconnect) {
    t2 = async () => {
      await disconnect();
      FlowActions.endFlow();
    };
    $[2] = disconnect;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleLogout = t2;
  const [isSwitchingWallet, setIsSwitchingWallet] = useState(false);
  if (isSwitchingWallet) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <SwitchWalletContent onCancel={() => setIsSwitchingWallet(false)} />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProfileDropdownItemAvatar icon={ContentCopy} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("copyWalletAddress");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <ProfileDropdownItemContent><ProfileDropdownItemTitle>{t4}</ProfileDropdownItemTitle></ProfileDropdownItemContent>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== copyAddress || $[11] !== t5) {
    t6 = <ProfileDropdownItem onClick={copyAddress}>{t3}{t5}</ProfileDropdownItem>;
    $[10] = copyAddress;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ProfileDropdownItemAvatar icon={Person} />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("viewProfile");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <ProfileDropdownItem href="/profile">{t7}<ProfileDropdownItemContent><ProfileDropdownItemTitle>{t8}</ProfileDropdownItemTitle></ProfileDropdownItemContent></ProfileDropdownItem>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== handleLogout || $[19] !== isProfileOwner || $[20] !== t) {
    t10 = isProfileOwner && <><DropdownSeparator /><ProfileDropdownItem onClick={e => {
        e.preventDefault();
        setIsSwitchingWallet(true);
      }}><ProfileDropdownItemAvatar icon={SwapHoriz} /><ProfileDropdownItemContent><ProfileDropdownItemTitle>{t("switchProfile")}</ProfileDropdownItemTitle></ProfileDropdownItemContent></ProfileDropdownItem><ProfileDropdownItem className="text-error-1" onClick={handleLogout}><ProfileDropdownItemAvatar className="text-inherit" icon={Logout} /><ProfileDropdownItemContent><ProfileDropdownItemTitle className="text-inherit">{t("logout")}</ProfileDropdownItemTitle></ProfileDropdownItemContent></ProfileDropdownItem></>;
    $[18] = handleLogout;
    $[19] = isProfileOwner;
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6 || $[24] !== t9) {
    t11 = <>{t6}{t9}{t10}</>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}